//header
import React from 'react';
import { View, Text, ScrollView, Platform } from 'react-native';
import TermsAndConditions from '../screens/customer/TermsAndConditions';
import styles from '../styles/model';
import HocComponent from './Hoc';
const TermsModel = (props) => {
  const bodyContainer = `bodyContainer_${props.measure}`;

  return (
    <View style={styles.modelContainer}>
      <View style={[styles.bodyContainer, styles[bodyContainer]]}>
        <ScrollView style={Platform.OS === 'ios' ? { width: '100%' } : {}}>
          <TermsAndConditions
            hideTerms={props.hideTerms}
            customerId={props.customerId}
          />
        </ScrollView>
      </View>
    </View>
  );
};

export default HocComponent(TermsModel);
